import { useQuery } from '@tanstack/react-query';
import { useApiClientContext } from '../../surveys/context';
import { ICustomSurveyResponse, IOperationResultNoValue } from '../../surveys/models/Api';

export const GET_CUSTOM_SURVEY_RESPONSE_BY_TOKEN_QUERY_KEY = 'getByTokenQueryCustomSurveyKey';

export const useClientGetCustomSurveyResponseByToken = ({
	accessToken,
	enabled = true,
	refetchOnWindowFocus = false,
	retry,
}: {
	accessToken: string;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
	retry?: boolean | number | ((failureCount: number, error: IOperationResultNoValue) => boolean);
}) => {
	const { apiClient } = useApiClientContext();

	return useQuery({
		enabled,
		queryFn: () => {
			return apiClient.get<ICustomSurveyResponse>(`survey/custom/response/byToken?token=${accessToken}`);
		},
		queryKey: [GET_CUSTOM_SURVEY_RESPONSE_BY_TOKEN_QUERY_KEY, accessToken],
		refetchOnWindowFocus,
		retry,
	});
};
